"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeBrightness = void 0;

// takes 6-digit hex colors, with or without preceding '#', e.g. '#bad304'
var changeBrightness = function changeBrightness(color, amount) {
  return color.replace(/\w\w/g, function (hex) {
    return ('0' + Math.min(255, Math.max(0, parseInt(hex, 16) + amount)).toString(16)).substr(-2);
  });
};

exports.changeBrightness = changeBrightness;